import { findControls } from "@plugins";
import Swiper, { Navigation } from "swiper";

Swiper.use([Navigation]);

const benefitsSlider = document.querySelector(".js-benefits-slider-init");

if (benefitsSlider) {
    const benefitsSliderControls = findControls(benefitsSlider, ".js-benefits-slider-controls");
    const benefitsSliderContainer = benefitsSlider.querySelector(".js-benefits-slider-inner");
    new Swiper(benefitsSliderContainer, {
        spaceBetween: 10,
        navigation: {
            nextEl: benefitsSliderControls.buttonNext,
            prevEl: benefitsSliderControls.buttonPrev,
        },
    });
}
